$(function () {
  $('[data-nav-trigger]').on('click', function () {
    $(this).toggleClass('active');
    $('[data-nav]').toggleClass('visible');
    $('.p-header').toggleClass('is-open');
  });

  
});
